// extracted by mini-css-extract-plugin
export var articleWrapper = "k_nB";
export var articleText = "k_nC d_dv d_cs";
export var header = "k_nD d_Z d_w";
export var headerImageWrapper = "k_nF d_bd d_0 d_8 d_7 d_4 d_9 d_bk d_bR";
export var headerGradient = "k_nG d_bd d_0 d_8 d_7 d_4 d_9";
export var headerGradientOverlay = "k_nH d_bd d_0 d_8 d_7 d_4 d_9";
export var headerContentWrapper = "k_nJ d_bz d_bP d_bD d_bJ d_bl d_Z";
export var headerContentWrapperAlt = "k_nK d_bz d_bP d_bD d_bJ d_bl d_Z";
export var contentWrapper = "k_mS d_w";
export var dateTag = "k_nL d_cf d_cr d_dq d_w";
export var icon1 = "k_nM d_cP";
export var icon2 = "k_nN d_cP d_cJ";
export var tagBtn = "k_nP d_b1 d_cD d_dp d_dB";
export var headerText = "k_nQ d_w d_cf d_cs d_bW";
export var center = "k_nR d_dw";
export var videoIframeStyle = "k_nS d_d5 d_w d_H d_by d_b1 d_R";
export var articleImageWrapper = "k_nT d_cs d_Z";
export var articleImageWrapperIcon = "k_nV d_cs d_Z";
export var articleRow = "k_nW d_bD";
export var quoteWrapper = "k_gQ d_bC d_bP d_cs";
export var quoteBar = "k_nX d_H";
export var quoteText = "k_nY";
export var authorBox = "k_nZ d_w";
export var authorRow = "k_n0 d_bD d_bW d_cy";
export var separator = "k_n1 d_w";
export var line = "k_fk d_w d_fk d_cY d_cy";
export var authorImage = "k_ln d_b7 d_Z d_w d_ct";
export var authorText = "k_n2 d_ch d_ct";
export var masonryImageWrapper = "k_n3";
export var bottomSeparator = "k_n4 d_w d_cy";
export var linksWrapper = "k_n5 d_ch d_dv";
export var comments = "k_n6 d_bD d_cy";
export var sharing = "k_n7 d_bz d_bD d_bJ";
export var shareText = "k_n8 d_w d_dw";
export var icon = "k_n9";
export var customRow = "k_pb d_bD d_Z";
export var text = "k_pc";
export var SubtitleSmall = "k_pd";
export var SubtitleNormal = "k_pf";
export var SubtitleLarge = "k_pg";